import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { checkClient } from '../lib/ftcPreflight';

const FIELDS = [
  ['fullName', 'Full name'], ['dateOfBirth', 'Date of birth'], ['ssn', 'SSN'], ['address', 'Street address'],
  ['city', 'City'], ['state', 'State'], ['zipCode', 'ZIP'], ['phone', 'Phone'], ['email', 'Email'],
];
export const toCheck = (c) => ({ name: c.fullName, dob: c.dateOfBirth, ssn: c.ssn, address: c.address, city: c.city, state: c.state, zip_code: c.zipCode, phone: c.phone, email: c.email });

// Live list of anything wrong with the client info (address = phone number, SSN in the phone box, etc).
export const ClientInfoCheck = ({ clientInfo }) => {
  const issues = checkClient(toCheck(clientInfo));
  if (!issues.length) return <p className="text-xs text-emerald-300 flex items-center gap-1" data-testid="client-info-check-ok"><CheckCircle2 className="w-3.5 h-3.5" />Client info looks right.</p>;
  return (
    <ul className="rounded-lg border border-red-500/40 bg-red-950/30 p-2 space-y-1" data-testid="client-info-check">
      {issues.map((i, n) => (
        <li key={n} className={`text-xs flex gap-1 ${i.level === 'error' ? 'text-red-200' : 'text-amber-200'}`}><AlertTriangle className="w-3.5 h-3.5 shrink-0" />{i.msg}</li>
      ))}
    </ul>
  );
};

// Inline editor for every client field — used on Step 3 so a saved report's personal info can be fixed in place.
export default function ClientInfoEditor({ clientInfo, setClientInfo }) {
  return (
    <div className="space-y-2" data-testid="client-info-editor">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {FIELDS.map(([k, label]) => (
          <label key={k} className={`text-[11px] text-zinc-400 ${k === 'address' ? 'sm:col-span-2' : ''}`}>
            {label}
            <input value={clientInfo[k] || ''} onChange={(e) => setClientInfo((c) => ({ ...c, [k]: e.target.value }))}
              className="mt-0.5 w-full rounded-md border border-zinc-700 bg-zinc-950 px-2 py-1.5 text-sm text-white focus:border-blue-500 outline-none"
              data-testid={`client-edit-${k}`} />
          </label>
        ))}
      </div>
      <ClientInfoCheck clientInfo={clientInfo} />
    </div>
  );
}
